import Meatballs from "@/Icons/Meatballs";
import { useGlobalAlert } from "@/States/globalAlert";
import resetOnSwitchClient from "@/Utils/resetOnSwitchClient";
import { trpc } from "@/Utils/trpc";
import useClickoutside from "@/Utils/useClickoutside";
import { useSelectedSite } from "@/api/hooks/useSelectedSite";
import { useSites } from "@/api/hooks/useSites";
import { useConfirmationDialog } from "@/components/Overlays/ConfirmationDialog";
import { Button } from "@/components/button";
import { useTrans } from "@/translations";

import { FC, useRef, useState } from "react";

import { twMerge } from "tailwind-merge";

type ContextMenuProps = {
  siteName: string | null;
  siteId: string;
};

const ContextMenu: FC<ContextMenuProps> = ({ siteName, siteId }) => {
  const { t } = useTrans();
  const { setGlobalAlert } = useGlobalAlert();
  const { selectedSite } = useSelectedSite();
  const { openConfirmationDialog } = useConfirmationDialog();
  const { refetch } = useSites();

  const containerWrapper = useRef(null);
  useClickoutside(containerWrapper, () => setShowButtons(false));

  const [showButtons, setShowButtons] = useState<boolean>(false);

  const { mutate: deleteClient, isPending: isDeleting } =
    trpc.config.deleteClient.useMutation({
      onSuccess: () => {
        setGlobalAlert({
          type: "success",
          message: "systemMessages:clientDeleted",
        });

        if (selectedSite?.id === siteId) {
          resetOnSwitchClient();
        } else {
          refetch();
        }
      },
      onError: (error) => {
        setGlobalAlert({
          type: "error",
          message: error.message,
        });
      },
    });

  return (
    <>
      <button
        onClick={() => setShowButtons(!showButtons)}
        className={twMerge(
          "pointer hover:bg-grey2 flex h-8 w-8 rotate-90 cursor-pointer justify-center rounded-md p-1.5",
          showButtons && "bg-grey3",
        )}
      >
        <Meatballs />
      </button>
      {showButtons && (
        <div
          ref={containerWrapper}
          className="border-grey2 absolute right-0 z-20 mt-1 border shadow-sm"
        >
          <Button
            label="actions:delete"
            className="text-carrot-red hover:bg-grey1 flex h-12 w-40 items-center border bg-white pl-4 text-sm"
            onClick={() => {
              openConfirmationDialog(
                "actions:deleteClient",
                () => deleteClient({ siteId: siteId.toString() }),
                t("hints:areYouSureDelete", {
                  name: siteName || t("formLabels:client").toLowerCase(),
                }),
              );
            }}
            clipped={false}
            disabled={isDeleting}
          />
        </div>
      )}
    </>
  );
};

export default ContextMenu;
